import * as CONSTANTS from "../constants/actions/modal";

/**
 * @name openModal
 * @function
 * @description Opens the modal.
 */
export const openModal = () => {
  return (dispatch) => dispatch({ type: CONSTANTS.SHOW_MODAL });
};

/**
 * @name closeModal
 * @function
 * @description Closes the modal.
 */
export const closeModal = () => {
  return (dispatch) => dispatch({ type: CONSTANTS.HIDE_MODAL });
};

/**
 * @name setModalState
 * @function
 * @description Set the value of all the fields in the modal.
 * @param {Object} parameters
 */
export const setModalState = (parameters) => {
  return (dispatch) =>
    dispatch({ type: CONSTANTS.SET_VALUES, payload: parameters });
};
